import { DetailApi, DetailApiImpl } from '@/domains/project/apis/detail-api';
import { DetailService, DetailServiceImpl } from '@/domains/project/services/detail-service';
import { WorkspaceApi, WorkspaceApiImpl } from '@/domains/project/apis/workspace-api';
import { WorkspaceService, WorkspaceServiceImpl } from '@/domains/project/services/workspace-service';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ProjectService, ProjectServiceImpl } from './services';
import { ReportApi, ReportApiImpl } from './apis/report-api';
import { ReportService, ReportServiceImpl } from './services/report-service';
import { SuggestApi, SuggestApiImpl } from './apis/suggest-api';
import { SuggestService, SuggestServiceImpl } from './services/suggest-service';

export const projectContainer = new ContainerModule(bind => {
    bind(ProjectService).to(ProjectServiceImpl);
    bind(SuggestApi).to(SuggestApiImpl);
    bind(DetailApi).to(DetailApiImpl);
    bind(DetailService).to(DetailServiceImpl);
    bind(WorkspaceApi).to(WorkspaceApiImpl);
    bind(WorkspaceService).to(WorkspaceServiceImpl);
    bind(ReportApi).to(ReportApiImpl);
    bind(ReportService).to(ReportServiceImpl);
    bind(SuggestService).to(SuggestServiceImpl);
});
